import { ActionTypes } from './constants';

export const setDeviceType = device => ({
    type: ActionTypes.SET_DEVICE_TYPE,
    payload: device,
});
